import * as React from "react";
const SvgEmailSetting = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "email_setting_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "email_setting_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 12,
	cy: 17,
	r: .17,
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M1 2v15a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1 1 1 0 0 0-1-1H3V3.92l7.87 5.51a2 2 0 0 0 2.26 0L21 3.92V16h-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m4.17 1h13.66L12 7.78Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17 18v-2h-1a4.1 4.1 0 0 0-.47-1.14l.68-.69-1.41-1.41-.69.68A4 4 0 0 0 13 13v-1h-2v1a4.1 4.1 0 0 0-1.14.47l-.69-.68-1.41 1.38.68.69A4.1 4.1 0 0 0 8 16H7v2h1a4.1 4.1 0 0 0 .47 1.14l-.68.69 1.41 1.41.69-.68A4 4 0 0 0 11 21v1h2v-1a4.1 4.1 0 0 0 1.14-.47l.69.68 1.41-1.41-.68-.69A4 4 0 0 0 16 18Zm-7.17-1A2.17 2.17 0 1 1 12 19.17 2.18 2.18 0 0 1 9.83 17",
	style: { fill: "currentColor" }
}))));
export default SvgEmailSetting;
